export default "__VITE_ASSET__CqrXMz7k__"